import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { debounceTime, fromEvent, Observable } from 'rxjs';
import { RootState } from './store/root.reducer';
import * as UserActions from './store/user/actions/user.actions'
import { ComponentSubscriber } from './helpers/subscriber.component';
import * as WindowActions from './store/ui/window/actions/window-detail.actions'
import { selectWindowWidth } from './store/ui/window/selectors/window-detail.selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent extends ComponentSubscriber implements OnInit {
  isCollapsed = false;
  currentWindowWidth$: Observable<number>
  constructor(
    private store: Store<RootState>,
  ) {
    super()
  }
  public ngOnInit(): void {
    this.store.dispatch(UserActions.autoSignIn())
    this.store.dispatch(WindowActions.setDocumentSize({ documentHeight: document.body.offsetHeight, documentWidth: document.body.offsetWidth }))

    //listen window size
    const updateWindow$ = fromEvent(window, 'resize').pipe(debounceTime(300)).subscribe(() => {

      this.store.dispatch(WindowActions.setDocumentSize({
        documentHeight: document.body.offsetHeight,
        documentWidth: document.body.offsetWidth
      }))
    })
    this.subscriptions.push({
      name: 'window size check',
      subscription: updateWindow$
    })
    this.currentWindowWidth$ = this.store.select(selectWindowWidth)
    //this.store.dispatch(DelvieryActions.fetchDeliveryByCustomerCode({custCode:"CE745859"}))//remove it after test
  }
}
